import React from 'react';

const HomePage: React.FC = () => {
  return (
    <div>
      Home Page
      <h1>Hello</h1>
      <h1>Hello</h1>
      <h1>Hello</h1>
      <h1>Hello</h1>
    </div>
  );
};

export default HomePage;
